import React from "react";
import { ChevronDown } from "lucide-react";
import { Input } from "components/ui/input";
import FilterField from "./FilterField";

export type CityOption = {
    value: string;
    label: string;
    lat: number;
    lon: number;
};

export type CityFeature = {
    properties: {
        label: string;
        city?: string;
        context?: string;
    };
    geometry: {
        coordinates: [number, number];
    };
};

const filterInputClassName =
    "h-11 w-full touch-manipulation rounded-[10px] border-gray-200 bg-white px-4 pr-10 text-sm font-normal text-neutral-950 shadow-none placeholder:text-transparent hover:bg-gray-50 focus-visible:ring-2";

type CityFilterProps = {
    label: string;
    inputValue: string;
    options: CityOption[];
    onInputChange: (value: string) => void;
    onSelect: (option: CityOption) => void;
};

const CityFilter: React.FC<CityFilterProps> = ({ label, inputValue, options, onInputChange, onSelect }) => (
    <FilterField label={label}>
        <div className="relative">
            <Input
                aria-label={label}
                autoComplete="off"
                className={filterInputClassName}
                name="filter_city"
                onChange={(event) => onInputChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === "Enter" && options[0]) {
                        event.preventDefault();
                        onSelect(options[0]);
                    }
                }}
                value={inputValue}
            />
            <ChevronDown
                aria-hidden="true"
                className="pointer-events-none absolute right-4 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
            />
            {options.length > 0 ? (
                <div className="absolute left-0 top-12 z-50 max-h-72 w-full overflow-auto rounded-lg border border-gray-200 bg-white p-1 shadow-md">
                    {options.map((option) => (
                        <button
                            key={`${option.value}-${option.lat}-${option.lon}`}
                            className="block w-full rounded-md px-3 py-2 text-left text-sm text-neutral-950 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                            type="button"
                            onClick={() => onSelect(option)}
                        >
                            <span className="block truncate">{option.label}</span>
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    </FilterField>
);

export default CityFilter;
